import { use } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './en/translation.json';
import id from './id/translation.json';
import { languages } from './languages';
import { convertLanguageJsonToObject } from './translations';

export const translationsJson = {
  en: {
    translation: en,
  },
  id: {
    translation: id,
  },
};
const { en: EN, id: ID } = languages;

// Create the 'translations' object to provide full intellisense support for the static json files.
convertLanguageJsonToObject(en);

export const i18n =
  // pass the i18n instance to react-i18next.
  // eslint-disable-next-line react-hooks/rules-of-hooks
  use(LanguageDetector)
    .use(initReactI18next)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      supportedLngs: [EN, ID],
      lng: EN,
      detection: {
        order: ['path', 'cookie', 'htmlTag'],
        caches: ['cookie'],
      },
      resources: translationsJson,
      fallbackLng: EN,
      debug:
        import.meta.env.VITE_ENV !== 'production' &&
        import.meta.env.VITE_ENV !== 'test',

      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      backend: {
        loadPath: './{{lng}}/translation.json',
      },
    });
